import { render, staticRenderFns } from "./SalesChannelList.vue?vue&type=template&id=486866af&scoped=true&"
import script from "./SalesChannelList.vue?vue&type=script&lang=js&"
export * from "./SalesChannelList.vue?vue&type=script&lang=js&"
import style0 from "./SalesChannelList.vue?vue&type=style&index=0&id=486866af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486866af",
  null
  
)

export default component.exports